import { Form } from "react-bootstrap";

export type VrboUpdatePropertyOptions = {
    general: boolean
    location: boolean
    policies: boolean
    amenities: boolean
}

export const ALL_VRBO_UPDATE_PROPERTY_OPTIONS: VrboUpdatePropertyOptions = { general: true, location: true, policies: true, amenities: true }

const SECTIONS: { key: keyof VrboUpdatePropertyOptions, label: string, description: string }[] = [
    { key: 'general', label: 'General info', description: 'Name, type and description' },
    { key: 'location', label: 'Address / location', description: 'Coordinates and address (VRBO ignores these while the listing is active)' },
    { key: 'policies', label: 'Policies', description: 'Booking, check-in/out, occupancy and stay policies' },
    { key: 'amenities', label: 'Amenities', description: 'Mapped property amenities' },
]

export function hasVrboUpdatePropertySelection(options: VrboUpdatePropertyOptions) {
    return Object.values(options).some(Boolean)
}

export default function VrboUpdatePropertyOptionsForm(
    props: {
        options: VrboUpdatePropertyOptions
        onChange: (options: VrboUpdatePropertyOptions) => void
        idPrefix?: string
        disabled?: boolean
    }
) {
    const { options, onChange, idPrefix = 'vrbo-update-property', disabled = false } = props

    return (
        <>
            {SECTIONS.map(({ key, label, description }) => (
                <Form.Check
                    key={key}
                    id={`${idPrefix}-${key}`}
                    type="checkbox"
                    label={<span><strong>{label}</strong> <small className="text-muted">{description}</small></span>}
                    checked={options[key]}
                    onChange={(e) => onChange({ ...options, [key]: e.target.checked })}
                    disabled={disabled}
                    className="mb-2"
                />
            ))}
        </>
    )
}
